export enum SupplierTypeGroup {
    SOFTWARE_SAAS = "software_saas",
    CLOUD_INFRASTRUCTURE = "cloud_infrastructure",
    PROFESSIONAL_SERVICES = "professional_services",
    HR_STAFFING = "hr_staffing",
    MANUFACTURING_INDUSTRIAL = "manufacturing_industrial",
    LOGISTICS_SUPPLY_CHAIN = "logistics_supply_chain",
    FACILITIES_REAL_ESTATE = "facilities_real_estate",
    MARKETING_CREATIVE = "marketing_creative",
    FINANCIAL_SERVICES = "financial_services",
    TELECOM_CONNECTIVITY = "telecom_connectivity",
    OTHER_CUSTOM = "other_custom",
}

export enum EvaluationGoal {
    NEW_SUPPLIER_EVALUATION = "new_supplier_evaluation",
    RENEWAL_DECISION = "renewal_decision",
    CONTRACT_NEGOTIATION_PREP = "contract_negotiation_prep",
    RISK_ASSESSMENT = "risk_assessment",
    COMPETITIVE_COMPARISON = "competitive_comparison",
    DUE_DILIGENCE = "due_diligence",
}

export enum BriefAddon {
    ESG_SUSTAINABILITY = "esg_sustainability",
    PARTNERSHIP_ECOSYSTEM = "partnership_ecosystem",
    CUSTOMER_CHURN_RETENTION = "customer_churn_retention",
    CASE_STUDIES_REFERENCES = "case_studies_references",
}

export enum BriefStatus {
    DRAFT = "draft",
    PROCESSING = "processing",
    COMPLETED = "completed",
    FAILED = "failed",
}

export enum BriefJobStatus {
    QUEUED = "queued",
    RESEARCHING = "researching",
    VERIFYING = "verifying",
    RENDERING = "rendering",
    COMPLETED = "completed",
    FAILED = "failed",
}

export enum Verdict {
    STRONG_YES = "STRONG_YES",
    YES = "YES",
    CONDITIONAL = "CONDITIONAL",
    RENEGOTIATE = "RENEGOTIATE",
    NO = "NO",
    STRONG_NO = "STRONG_NO",
}

export interface BuyerBriefIntake {
    supplierName: string;
    supplierWebsite?: string;
    supplierType: SupplierTypeGroup;
    evaluationGoal: EvaluationGoal;
    selectedTopics: string[];
    selectedAddons: BriefAddon[];
    budgetRange?: string;
    customerContext?: string;
    priorityTopic?: string;
}

export interface BuyerBrief {
    id: number;
    organizationId: number;
    creatorId: number;
    supplierId?: number;
    status: BriefStatus;
    supplierName: string;
    supplierWebsite?: string;
    supplierType: SupplierTypeGroup;
    evaluationGoal: EvaluationGoal;
    selectedTopics: string[];
    selectedAddons: BriefAddon[];
    intakePayload: BuyerBriefIntake;
    briefOutput?: any;
    briefHtml?: string;
    verificationResult?: any;
    verdict?: Verdict;
    modelUsed?: string;
    webSearchesExecuted: number;
    errorDetails?: any;
    recordCreationDate: string;
    recordCompletionDate?: string;
    recordDeletionDate?: string;
}

export interface BuyerBriefJob {
    id: number;
    organizationId: number;
    briefId: number;
    supplierName?: string;
    jobType: string;
    status: BriefJobStatus;
    currentStep?: string;
    startTime: string;
    endTime?: string;
    failedReason?: any;
    retryCount: number;
}

export const SUPPLIER_TYPE_LABELS: Record<SupplierTypeGroup, string> = {
    [SupplierTypeGroup.SOFTWARE_SAAS]: "Software / SaaS",
    [SupplierTypeGroup.CLOUD_INFRASTRUCTURE]: "Cloud & Infrastructure",
    [SupplierTypeGroup.PROFESSIONAL_SERVICES]: "Professional Services",
    [SupplierTypeGroup.HR_STAFFING]: "HR & Staffing",
    [SupplierTypeGroup.MANUFACTURING_INDUSTRIAL]: "Manufacturing & Industrial",
    [SupplierTypeGroup.LOGISTICS_SUPPLY_CHAIN]: "Logistics & Supply Chain",
    [SupplierTypeGroup.FACILITIES_REAL_ESTATE]: "Facilities & Real Estate",
    [SupplierTypeGroup.MARKETING_CREATIVE]: "Marketing & Creative",
    [SupplierTypeGroup.FINANCIAL_SERVICES]: "Financial Services",
    [SupplierTypeGroup.TELECOM_CONNECTIVITY]: "Telecom & Connectivity",
    [SupplierTypeGroup.OTHER_CUSTOM]: "Other / Custom",
};

export const EVALUATION_GOAL_LABELS: Record<EvaluationGoal, string> = {
    [EvaluationGoal.NEW_SUPPLIER_EVALUATION]: "New Supplier Evaluation",
    [EvaluationGoal.RENEWAL_DECISION]: "Renewal Decision",
    [EvaluationGoal.CONTRACT_NEGOTIATION_PREP]: "Contract Negotiation Prep",
    [EvaluationGoal.RISK_ASSESSMENT]: "Risk Assessment",
    [EvaluationGoal.COMPETITIVE_COMPARISON]: "Competitive Comparison",
    [EvaluationGoal.DUE_DILIGENCE]: "Due Diligence",
};

export const BRIEF_ADDON_LABELS: Record<BriefAddon, string> = {
    [BriefAddon.ESG_SUSTAINABILITY]: "ESG & Sustainability",
    [BriefAddon.PARTNERSHIP_ECOSYSTEM]: "Partnership Ecosystem",
    [BriefAddon.CUSTOMER_CHURN_RETENTION]: "Customer Churn & Retention",
    [BriefAddon.CASE_STUDIES_REFERENCES]: "Case Studies & References",
};

export const VERDICT_LABELS: Record<Verdict, string> = {
    [Verdict.STRONG_YES]: "Strong Yes",
    [Verdict.YES]: "Yes",
    [Verdict.CONDITIONAL]: "Conditional",
    [Verdict.RENEGOTIATE]: "Renegotiate",
    [Verdict.NO]: "No",
    [Verdict.STRONG_NO]: "Strong No",
};

export const STATUS_LABELS: Record<BriefStatus, string> = {
    [BriefStatus.DRAFT]: "Draft",
    [BriefStatus.PROCESSING]: "Processing",
    [BriefStatus.COMPLETED]: "Completed",
    [BriefStatus.FAILED]: "Failed",
};
